import FormArtistServices from '../../services/form_artist';

export const state = {
    artists: [],
    artist: {},
}

export const mutations = {
    setArtist(state, artist) {
        state.artist = artist
    },
    setArtists(state, artists) {
        state.artists = artists
    }
}

export const getters = {
    getArtist(state) {
        return state.artist;
    },
    getArtists(state) {
        return state.artists;
    },
}

export const actions = {
    get({commit}, id){
        return FormArtistServices.get(id)
        .then((response)=>{
            commit('setArtist', response.data.data)
            return response
        })
    },
    getAll({commit}, data = {}){
        return FormArtistServices.getAll(data)
        .then((response)=>{
            commit('setArtists', response.data.data)
            return response
        })
    },
    delete({state, commit}, id){
        return FormArtistServices.delete(id)
        .then((response)=>{
            commit('setArtists', state.artists.filter((x)=>x.id != id))
            return response
        })
    },
}